module.exports = __webpack_public_path__ + "static/img/row3.814565c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row3.png
// module id = 1UHQ
// module chunks = 12